import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import styled from 'styled-components';

import {compose, graphql} from 'react-apollo';
import PropTypes from 'prop-types';
import React, {Component} from 'react';
import gql from 'graphql-tag';

import {CONTENT_IMAGE} from '../Content/contentConstants';
import {Label} from '../FormElements';
import Item from './Item';
import MediaUploader from './MediaUploader';

const ItemListWrapper = styled.div`
  height: 500px;
  padding-top: 20px;
  margin: 0 -15px;
  overflow-y: scroll;
`;

const ItemTitle = styled.div`
  position: absolute;
  height: 30px;
  bottom: 0;
  left: 0;
  right: 0;
  font-size: 10px;
  line-height: 15px;
  color: black;
  background: rgba(255, 255, 255, 0.7);
`;

const customContentStyle = {
  width: '90%',
  maxWidth: 'none',
};

const customBodyStyle = {
  flex: 1,
  flexDirection: 'column',
  display: 'flex',
  paddingBottom: 0,
};

const Image = styled.img`
  max-width: 150px;
  max-height: 100px;
  margin: auto;
  background: #efefef;
`;

const Other = styled.div`
  width: 150px;
  height: 100px;
  background: #efefef;
  display: flex;
  align-items: center;
  justify-content: center;
  word-break: break-all;
  box-sizing: border-box;
`;

const renderItem = ({filePath, title, type}, config) => {
  if (type === CONTENT_IMAGE) {
    return (
      <div>
        <ItemTitle>{title}</ItemTitle>
        <Image alt={title} src={config.thumbBaseUrl + filePath} />
      </div>
    );
  }
  return <Other>{title}</Other>;
};

class MediaPicker extends Component {
  static propTypes = {
    config: PropTypes.object.isRequired,
    multiple: PropTypes.bool.isRequired,
    onSelect: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired,
    type: PropTypes.oneOf(['image', 'other']),
    values: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  };

  constructor(props) {
    super(props);
    this.state = {
      open: false,
      selectedItems: this._handleSelected(props.values),
    };
  }

  handleUploaded = (media) => {
    this.props.mediaQuery.updateQuery(({allMedia, ...prev}) => ({
      ...prev,
      allMedia: [{...media, __typename: 'Media'}, ...allMedia],
    }));
  };

  componentWillReceiveProps = ({values}) => {
    this.setState({selectedItems: this._handleSelected(values)});
  };

  _handleSelected = (values) => {
    let selectedItems = [];
    if (values !== null) {
      if (values instanceof Array) {
        selectedItems = values;
      } else {
        selectedItems.push(values);
      }
    }
    return selectedItems;
  };

  _open = () => this.setState({open: true});

  _save = () => {
    this.props.onSelect(this.state.selectedItems);
    this.setState({open: false});
  };

  _selectItem = (item) => {
    if (this.props.multiple === true) {
      let selectedItems;
      if (this._isSelected(item)) {
        selectedItems = this.state.selectedItems.filter(({_id}) => _id !== item._id);
      } else {
        selectedItems = [...this.state.selectedItems, item];
      }
      this.setState({selectedItems});
    } else {
      if (this._isSelected(item)) {
        this.setState({selectedItems: []});
      } else {
        this.setState({selectedItems: [item]});
      }
    }
  };

  _sortSelectedFirst = (arr) =>
    arr.concat().sort((a, b) => {
      if (this._isSelected(a)) return -1;
      if (this._isSelected(b)) return 1;
    });

  _isSelected = ({_id}) => this.state.selectedItems.findIndex((i) => i._id === _id) !== -1;

  renderItemList = (config) => {
    if (this.props.mediaQuery.loading) {
      return <div>loading</div>;
    } else {
      return (
        <ItemListWrapper>
          {this.props.mediaQuery.allMedia &&
            this.props.mediaQuery.allMedia.length > 0 &&
            this._sortSelectedFirst(this.props.mediaQuery.allMedia).map((item, idx) => (
              <Item isSelected={this._isSelected(item)} key={idx} onClick={() => this._selectItem(item)}>
                {renderItem(item, config)}
              </Item>
            ))}
        </ItemListWrapper>
      );
    }
  };

  actions = [
    <FlatButton label='Abbrechen' onClick={() => this.setState({open: false})} />,
    <FlatButton label='Übernehmen' onClick={this._save} primary />,
  ];

  render = () => {
    const {type, title, config} = this.props;
    const fileTypes = type === 'image' ? ['jpg', 'jpeg', 'png'] : ['pdf'];
    return (
      <div className={this.props.className} style={this.props.style}>
        <Label>{title}</Label>
        <RaisedButton label={'Auswählen'} onClick={this._open} />
        <Dialog
          actions={this.actions}
          contentStyle={customContentStyle}
          bodyStyle={customBodyStyle}
          modal
          open={this.state.open}
          title={title}>
          <MediaUploader config={config} fileTypes={fileTypes} onUploadDone={this.handleUploaded} />
          {this.renderItemList(config)}
        </Dialog>
        <div>
          {this.state.selectedItems.length !== 0 &&
            this.state.selectedItems.map((item, idx) => {
              return <Item key={idx}>{renderItem(item, config)}</Item>;
            })}
        </div>
      </div>
    );
  };
}

const MediaQuery = gql`
  query allMedia($type: String!, $project: String!) {
    allMedia(type: $type, project: $project) {
      _id
      filePath
      type
      title
      project
    }
  }
`;

export const MediaQueryConfig = {
  name: 'mediaQuery',
  options: (props) => ({
    variables: {type: props.type, project: props.config.getProjectKey()},
    fetchPolicy: 'network-only',
  }),
};

export const HideMediaInListMutation = gql`
  mutation hideMediaInList($_id: String!) {
    hideMediaInList(_id: $_id) {
      _id
    }
  }
`;

export const HideMediaInListMutationConfig = {
  name: 'hideMediaInList',
  options: {
    updateQueries: {
      allMedia: (
        {allMedia, ...prev},
        {
          mutationResult: {
            data: {hideMediaInList},
          },
        }
      ) => ({
        ...prev,
        allImages: allMedia.filter(({_id}) => _id !== hideMediaInList._id),
      }),
    },
  },
};
export default compose(
  graphql(MediaQuery, MediaQueryConfig),
  graphql(HideMediaInListMutation, HideMediaInListMutationConfig)
)(MediaPicker);



// WEBPACK FOOTER //
// ./src/arkulpa-fec/components/MediaPicker/MediaPicker.js